import { SvgImage, SvgType } from '../../../../components/base/svg/svg';
import i18n from '../../../../translations/strings';

export const servicesLandingPage = [
  {
    name: i18n.t('landing.Recording'),
    description: i18n.t('landing.RecordingDesc'),
    svg: <SvgImage type={SvgType.Mixer} />,
  },
  {
    name: i18n.t('landing.LiveStreaming'),
    description: i18n.t('landing.LiveStreamingDesc'),
    svg: <SvgImage type={SvgType.LiveStreaming} />,
  },
  {
    name: i18n.t('landing.Mixer'),
    description: i18n.t('landing.MixerDesc'),
    svg: <SvgImage type={SvgType.Mixer} />,
  },
  {
    name: i18n.t('landing.WallLed'),
    description: i18n.t('landing.WallLedDesc'),
    svg: <SvgImage type={SvgType.WallLed} />,
  },
  {
    name: i18n.t('landing.BuffetAndApe'),
    description: i18n.t('landing.BuffetAndApeDesc'),
    svg: <SvgImage type={SvgType.BuffetAndAperitivi} />,
  },
  {
    name: i18n.t('landing.WelcomeCoffee'),
    description: i18n.t('landing.WelcomeCoffeeDesc'),
    svg: <SvgImage type={SvgType.WelcomeCoffee} />,
  },
];
